import React, { useState, useEffect, useCallback } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getUomTypes as getUomTypesService } from "../../../common/services/markets/uomTypeService";
import LoadingScreen from "../../../common/components/loading/loading";
import UomTypesTable from "./uomTypesTable";
import SearchBox from "../../../common/components/search/searchBox";
import _ from "lodash";
import Form from "react-bootstrap/Form";

const UomTypes = ({ onClick, allowEdit }) => {
  const { t } = useTranslation(["markets", "common"]);
  const [uomTypes, setUomTypes] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeOnly, setActiveOnly] = useState(true);
  const [sortColumn, setSortColumn] = useState({ path: "name", order: "asc" });
  const [loading, setLoading] = useState(true);
  const [paginationState, setPaginationState] = useState({
    currentPage: 0,
    pageSize: 20,
  });

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getUomTypesService();
        setUomTypes(data);
      } catch (error) {
        console.error("Error fetching UOM types:", error);
        toast.error(t("common:ErrorFetchingData"));
      } finally {
        setLoading(false);
      }
    })();
  }, [t]);

  const handleUomTypeUpdated = useCallback((uomType) => {
    setUomTypes((prevUomTypes) => {
      const updatedUomTypes = [...prevUomTypes];
      const index = updatedUomTypes.findIndex(
        (u) => u.uomTypeId === uomType.uomTypeId
      );
      if (index > -1) {
        updatedUomTypes.splice(index, 1);
      }
      updatedUomTypes.push(uomType);
      return updatedUomTypes;
    });
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setPaginationState((prev) => ({ ...prev, currentPage: 0 }));
  };

  const handleSort = (colId, sort) => {
    if (colId && sort) {
      setSortColumn({ path: colId, order: sort });
    }
  };

  const handleToggleActiveOnly = () => {
    setActiveOnly((prev) => !prev);
    setPaginationState((prev) => ({ ...prev, currentPage: 0 }));
  };

  const handleUomTypeSelected = (uomType, isNew = false) => {
    onClick(uomType, handleUomTypeUpdated, isNew);
  };

  const handlePaginationChange = (params) => {
    if (params && params.api) {
      setPaginationState({
        currentPage: params.api.paginationGetCurrentPage(),
        pageSize: params.api.paginationGetPageSize(),
      });
    }
  };

  const getFilteredData = () => {
    let filtered = uomTypes;
    if (activeOnly) filtered = filtered.filter((u) => u.active);
    if (searchQuery)
      filtered = filtered.filter(
        (uomType) =>
          uomType.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (uomType.description &&
            uomType.description
              .toLowerCase()
              .includes(searchQuery.toLowerCase()))
      );
    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    return { totalCount: filtered.length, data: sorted };
  };

  const handleAddUomType = () => {
    // Each draft needs its own tab identity, including after a previous save.
    handleUomTypeSelected({ uomTypeId: uuid(), name: t("NewUomType") }, true);
  };

  if (loading) return <LoadingScreen />;

  const { totalCount, data } = getFilteredData();

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <SearchBox value={searchQuery} onChange={handleSearch} />
        </div>
        <div className="col">
          <Form.Switch
            className="switch"
            type="switch"
            label={t("ActiveOnly")}
            checked={activeOnly}
            value={activeOnly}
            onChange={handleToggleActiveOnly}
          />
        </div>
        <div className="col">
          {allowEdit && (
            <button
              onClick={handleAddUomType}
              className="btn btn-sm btn-primary float-sm-right"
            >
              {t("AddUom")}
            </button>
          )}
        </div>
      </div>
      <p>{t("RetrievedUom", { count: totalCount })}</p>
      <UomTypesTable
        uomTypes={data}
        onSort={handleSort}
        onRowClick={handleUomTypeSelected}
        onPaginationChanged={handlePaginationChange}
        paginationState={paginationState}
      />
    </div>

    // <div className="container-fluid px-4">
    //   <div className="row mb-4">
    //     <div className="col-md-6">
    //       <h1 className="mt-4">{t("UomTypes")}</h1>
    //     </div>
    //     <div className="col-md-6 d-flex justify-content-end align-items-center">
    //       <SearchBox value={searchQuery} onChange={handleSearch} />
    //     </div>
    //   </div>

    //   <div className="row">
    //     <div className="col-md-12">
    //       <div className="card-body">
    //         <UomTypesTable
    //           uomTypes={data}
    //           onSort={handleSort}
    //           onRowClick={handleRowClick}
    //           onPaginationChanged={handlePaginationChange}
    //           paginationState={paginationState}
    //         />
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default UomTypes;
